import { render, staticRenderFns } from "./LoginCustomerService.vue?vue&type=template&id=019106a9&scoped=true"
import script from "./LoginCustomerService.vue?vue&type=script&lang=js"
export * from "./LoginCustomerService.vue?vue&type=script&lang=js"
import style0 from "./LoginCustomerService.vue?vue&type=style&index=0&id=019106a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019106a9",
  null
  
)

export default component.exports